import { render } from "./ClubModal.vue?vue&type=template&id=23006c71&scoped=true&ts=true"
import script from "./ClubModal.vue?vue&type=script&lang=ts"
export * from "./ClubModal.vue?vue&type=script&lang=ts"

import "./ClubModal.vue?vue&type=style&index=0&id=23006c71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23006c71"]])

export default __exports__